import { call, put, select } from 'redux-saga/effects';
import {
  resetUpdateAllocationAction,
  updateAllocationValueAction,
} from '../actions';
import ProductValueService from '@services/product-value-service/product-value-service';
import { enqueSnackAction } from '@app/store/snacks';
import { selectUpdateAllocation } from '../selectors';
import { UpdateAllocationValue } from '@app/shared/types/productValue';

export function* updateAllocationValueSaga(
  action: ReturnType<typeof updateAllocationValueAction>
) {
  try {
    const updateDate: Record<string, UpdateAllocationValue> = yield select(
      selectUpdateAllocation
    );
    const data = Object.keys(updateDate).map((item) => {
      return {
        valueAllocation: updateDate[item].valueAllocation,
        mainGroupId: item,
      };
    });
    yield call(ProductValueService.updateAllocationValue, { data });
    yield put(resetUpdateAllocationAction({}));

    yield put(
      enqueSnackAction({
        notification: {
          message: 'Allocations Value is saved',
          options: {
            variant: 'success',
          },
          key: 'save allocation level',
        },
      })
    );
  } catch (e) {
    if (e.response && e.response.status === 409) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'create product update value error',
          },
        })
      );
    }
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'create product update value error',
        },
      })
    );
    console.log(`Failed to update allocation value: ${e.toString()}`);
  }
}
